import Ajax from '@/lib/ajax_wrapper'

function companyUsersPath(companyId) {
  return `/admin/companies/${companyId}/users`
}

function companyUserPath(companyId, id) {
  return `${companyUsersPath(companyId)}/${id}`
}

/**
 * Read paginated users
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanyUsersData(id, page) {
  return Ajax.request({
    url: companyUsersPath(id),
    page: page
  })
}

/**
 * Create a company user
 *
 * @param {string} companyId
 * @param {object} user
 * @param {string} user.email
 *
 * @returns {promise}
 */
export function createCompanyUserData(companyId, user) {
  return Ajax.request({
    url: companyUsersPath(companyId),
    method: 'POST',
    data: {user}
  })
}

/**
 * Re-send invite email
 *
 * @param {string} companyId
 * @param {object} user
 * @param {string} user.email
 *
 * @returns {promise}
 */
export function resendCompanyUserData(companyId, userId) {
  return Ajax.request({
    url: `/companies/${companyId}/users/${userId}/resend_account_activation`,
    method: 'POST'
  })
}

/**
 * Read a company user
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readCompanyUserData(companyId, userId) {
  return Ajax.request({
    url: companyUserPath(companyId, userId)
  })
}

/**
 * Update a company user
 *
 * @param {string} id
 * @param {object} company user
 * @param {string} user.id
 *
 * @returns {promise}
 */
export function updateCompanyUserData(companyId, userId, user) {
  return Ajax.request({
    url: companyUserPath(companyId, userId),
    method: 'PATCH',
    data: {user}
  })
}

/**
 * Delete a company user
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteCompanyUserData(companyId, userId) {
  return Ajax.request({
    url: companyUserPath(companyId, userId),
    method: 'DELETE'
  })
}
